import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";


const fieldsConfig = {

    createRootProject : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : true,
        options         : [true, false]
    },

}


export default class CompanyRoleUserSettings extends ServerSettings {


    public createRootProject  : boolean

    constructor(config:any) {

        super(config, fieldsConfig);

        this.createRootProject                 = this.initValue('createRootProject')
    }

    toJson() {

        const result = {};

        this.valueToJson(result, 'createRootProject')

        return result;
    }

}